const size = {
	mobileS: "20em",
	mobileM: "23.438em",
	mobileL: "26.563em",
	mobileXL: "31.25em",
	tablet: "48em",
	tabletM: "50em",
	tabletL: "56em",
	laptop: "64em",
	laptopL: "90em",
	desktop: "160em",
}

export const device = {
	mobileS: `(min-width: ${size.mobileS})`,
	mobileM: `(min-width: ${size.mobileM})`,
	mobileL: `(min-width: ${size.mobileL})`,
	mobileXL: `(min-width: ${size.mobileXL})`,
	tablet: `(min-width: ${size.tablet})`,
	tabletM: `(min-width: ${size.tabletM})`,
	tabletL: `(min-width: ${size.tabletL})`,
	laptop: `(min-width: ${size.laptop})`,
	laptopL: `(min-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`,
}
